__turbopack_context__.v({
  "arrow": "Arrow-module-scss-module__Vk3eGG__arrow",
  "container": "Arrow-module-scss-module__Vk3eGG__container",
  "dashed": "Arrow-module-scss-module__Vk3eGG__dashed",
  "drawing": "Arrow-module-scss-module__Vk3eGG__drawing",
  "horizontal-flip": "Arrow-module-scss-module__Vk3eGG__horizontal-flip",
  "line": "Arrow-module-scss-module__Vk3eGG__line",
  "mask": "Arrow-module-scss-module__Vk3eGG__mask",
  "text-container": "Arrow-module-scss-module__Vk3eGG__text-container",
  "text-container-down": "Arrow-module-scss-module__Vk3eGG__text-container-down",
  "text-container-down-flipped": "Arrow-module-scss-module__Vk3eGG__text-container-down-flipped",
  "text-container-left": "Arrow-module-scss-module__Vk3eGG__text-container-left",
  "text-container-left-flipped": "Arrow-module-scss-module__Vk3eGG__text-container-left-flipped",
  "text-container-right": "Arrow-module-scss-module__Vk3eGG__text-container-right",
  "text-container-right-flipped": "Arrow-module-scss-module__Vk3eGG__text-container-right-flipped",
  "text-container-up": "Arrow-module-scss-module__Vk3eGG__text-container-up",
  "text-container-up-flipped": "Arrow-module-scss-module__Vk3eGG__text-container-up-flipped",
});
